import {
  apiClient,
  type TruckImportJobExEntity,
  type PageEntity
} from '@/libs/api'
import { type TruckImportJobsRequestQuery } from '@/libs/api/types'

export type FetchTruckImportJobsQuery = {
  tenantKey: string
  query: TruckImportJobsRequestQuery
}

export type FetchTruckImportJobsResponse = {
  data: TruckImportJobExEntity[]
  pagination: PageEntity | null
}

export const fetchTruckImportJobs = async (
  { tenantKey, query }: FetchTruckImportJobsQuery,
  signal?: AbortSignal
): Promise<FetchTruckImportJobsResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_import_jobs.$get({
      query,
      config: {
        signal
      }
    })
  return {
    data,
    pagination
  }
}
